/**
 * @file Contém as constantes do sumario
 */
const tipo = {
        ATO: 'A',
        ORGAO: 'O'
}
export default {tipo};
